import React from "react";
import { IconButton } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import CustomTooltip from "src/components/custom-tooltip";

const LinkButton = ({ handleClick, isProfilePrivate }) => {
    return (
        <CustomTooltip
            title={
                isProfilePrivate
                    ? "You profile is private. Enable via  your account settings"
                    : "Sharable link"
            }
        >
            <div>
                <IconButton
                    onClick={handleClick}
                    aria-label="delete"
                    size="small"
                    disabled={isProfilePrivate}
                >
                    <LinkIcon fontSize="small" />
                </IconButton>
            </div>
        </CustomTooltip>
    );
};

export default LinkButton;
